export default {
  title: '{entity1} con {entity2} activas',
  searchHelp: 'Puede buscar por nombre de {entity1} o por el ID del {entity2}.',
  activeEntity: '{entity} Activas',
  navigation: 'Navegación',
  showEntity: 'Ver {entity}',
  hideEntity: 'Ocultar {entity}',
  code: 'Código',
  noEntity: 'No hay {entity} para mostrar',
  searchEntityPlaceholder: 'Buscar {entity}...',
  showMore: '+{count} más',
  showLess: 'Mostrar menos',
  activeTestTooltip: '{entity} activas',
  state: 'Estado',
  closed: 'Cerrado',
  inProcess: 'En proceso',
  reportsNavigationTooltip: 'Ir directo a Reportes',
}
